module.exports = __webpack_public_path__ + "img/20190810114505QQ截图20190810015545.37793211.png";